import React, { useState } from 'react'
import moment from 'moment'
import actionbutton from "../../Assets/Images/Employee/✳️ secondary action.svg"
import { Link } from 'react-router-dom'

const ViewLeave = () => {
     const [isOpen, setIsOpen] = useState(false);

     const toggleDropdown = () => {
          setIsOpen(!isOpen);
     };
     return (
               <div className='view-container'>
                    <div className='view-header'>
                         <p className='view-title'>Leave Details</p>
                    </div>

                    <div className='view-card'>
                         <div className='view-leave-info'>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Applicant Name</p>
                                   <p className='card-row-value'>Meet Kumbhani</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Leave Date</p>
                                   <p className='card-row-value'>{moment().format('l')}</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Leave Type</p>
                                   <p className='card-row-value'>Casual</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Duration</p>
                                   <p className='card-row-value'>Full Day</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Reason for absence</p>
                                   <p className='card-row-value'>Going To Home</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Status</p>
                                   <p className='card-row-value leave-status'>Approve</p>

                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Actioned By</p>
                                   <p className='card-row-value'>HR</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Actioned At</p>
                                   <p className='card-row-value'>{moment().format('l')}</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Reason for leave approval</p>
                                   <p className='card-row-value'>Valid</p>
                              </div>
                              <div className='view-card-row'>
                                   <p className='card-row-title'>Files</p>
                                   <p className='card-row-value'>No File Uploded</p>
                              </div>

                              <div className="menu-button">
                                   <img
                                        src={actionbutton}
                                        alt="Menu"
                                        onClick={toggleDropdown}
                                        aria-expanded={isOpen}
                                        style={{ cursor: 'pointer' }}
                                   />

                                   {isOpen && (
                                        <div className="dropdown-menu show">
                                             <div className="d-grid">
                                                  <Link
                                                       className="dropdown-item"
                                                       to="/leave/approve"
                                                  >
                                                       Approve
                                                  </Link>

                                                  <Link
                                                       className="dropdown-item"
                                                       onClick={() => {
                                                            setIsOpen(false);
                                                       }}
                                                       to="/leave/reject"
                                                  >
                                                       Reject
                                                  </Link>
                                             </div>
                                        </div>
                                   )}
                              </div>
                         </div>

                    </div>
               </div>
     )
}

export default ViewLeave
